// import { toast } from "react-toastify";

const organizationReducer = (state = {}, action) => {
    switch (action.type) {
      case "FETCH_ORG_INFO":
        return {
          ...state,
          organization_info: action.payload,
        };
  
      default:
        return state;
    }
  };
  
  export default organizationReducer;